import gql from 'graphql-tag';

export const GET_PROGRAMME_LIST = gql`
  query ($input: ProgrammeListInput!){
    programmeList(input: $input) {
      id
      channel_id
      title
      start_time
      stop_time
      guide_xml
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/programme/list.js